import React, { Component } from "react";
import { Row, Col, Image } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import RejectIcon from "../../../assets/images/RejectIcon.svg";
import approved from "../../../assets/images/approved.svg";
import BoxArrowDown from "../../../assets/images/BoxArrowDown.svg";
import BoxArrowUp from "../../../assets/images/BoxArrowUp.svg";
import Scroll from "../../../assets/images/Scroll.svg";
import SealCheck from "../../../assets/images/SealCheck.svg";
import CaretRight from "../../../assets/images/CaretRight.svg";
import delivaApiService from "../../../common/services/apiService";
import {
  setLocalStorage,
  getLocalStorage,
  showErrorToast,
} from "../../../common/helpers/Utils";
import validateInput from "../../../common/validations/validateDetailsPA";
import CaretCircleDownAccordion from "../../../assets/images/CaretCircleDownAccordion.svg";
import "./processingAgentDetails.scss";

class StoreProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInviteVendors: false,
      allCustomers: [],
      pageno: 1,
      records: 10,
      sort: "",
      keyword: "",
      search: "",
      pAList: [],
      details: [],
      totalOrders: [],
      packageCOuntForPA: [],
      totalTrips: 0,
      showRejectModal: false,
      adminVerification: false,
      businessVerification: false,
      termsVerification: false,
      notarionVerification: false,
      internationalVerification: false,
      bankVerification: false,
      timeVerification: false,
      rejectionType: "resubmission",
      errors: {},
      rejectionReason: "Other",
      successModal: false,
      showLoader: false,
      selectedParcelCenter: null,
      description: "",
      expandedAccordions: {
        photos: true,
        businessDocs: true,
        internationalDocs: false,
        adminDocs: false,
      },
    };
  }

  componentDidMount() {
    this.setState(
      {
        id: this.props.location.state.id
          ? this.props.location.state.id
          : getLocalStorage("PAID"),
      },
      () => {
        if (this.props.location.state.id) {
          setLocalStorage("PAID", this.props.location.state.id);
        }
        this.getProcessingAgentDetail();
        this.getPackageCountForPA();
      },
    );
  }

  viewParcelCenter = (parcelCenter) => {
    const parcelCenterId = parcelCenter?.parcelCenterId || parcelCenter?.id;
    this.setState(
      {
        selectedParcelCenter: parcelCenter,
        expandedAccordions: {
          photos: true,
          businessDocs: true,
          internationalDocs: false,
          adminDocs: false,
        },
      },
      () => {
        this.getProcessingAgentDetail(parcelCenterId);
        this.getPackageCountForPA(parcelCenterId);
      },
    );
  };

  showParcelCenterList = () => {
    this.setState({ selectedParcelCenter: null }, () => {
      this.getProcessingAgentDetail();
      this.getPackageCountForPA();
    });
  };

  handleReject = (userId) => {
    this.setState({
      showRejectModal: !this.state.showRejectModal,
      userId,
    });
  };

  handleBlock = (userId) => {
    console.log("Block user:", userId);
  };

  getProcessingAgentDetail(parcelCenterId = null) {
    this.setLoader(true);
    delivaApiService(
      parcelCenterId
        ? "getProcessingAgentDetailForParcelCenter"
        : "getProcessingAgentDetail",
      { id: this.state.id, parcelCenterId },
    )
      .then((response) => {
        if (response && response.data) {
          const data = response.data.resourceData;
          const selectedParcelCenter = parcelCenterId
            ? data?.parcelCenter ||
              data?.parcelCenters?.find(
                (center) =>
                  String(center.parcelCenterId || center.id) ===
                  String(parcelCenterId),
              ) ||
              this.state.selectedParcelCenter
            : null;
          this.setState({
            details: data,
            selectedParcelCenter,
            showLoader: false,
          });
        } else {
          this.setLoader(false);
        }
      })
      .catch(() => {
        this.setLoader(false);
      });
  }

  getPackageCountForPA(parcelCenterId = null) {
    this.setLoader(true);
    delivaApiService(
      parcelCenterId
        ? "getPackageCountForParcelCenter"
        : "getPackageCountForPA",
      { userId: this.state.id, parcelCenterId },
    )
      .then((response) => {
        if (response && response.data) {
          const counts = response.data.resourceData || {};
          this.setState({
            packageCOuntForPA: counts,
            totalTrips:
              counts.totalProcessedOrderCount ||
              counts.totalOrderProcessedCount ||
              counts.totalTrips ||
              0,
            showLoader: false,
          });
        } else {
          this.setLoader(false);
        }
      })
      .catch(() => {
        this.setLoader(false);
      });
  }

  setLoader(showLoader) {
    this.setState({
      showLoader,
    });
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  approveDA = (userId, name) => {
    if (this.isValid()) {
      this.setState({
        showLoader: true,
        daName: name,
        userId: userId,
      });
      delivaApiService("approveDA", {
        userId,
        kycApprovedByAdmin: true,
        verificationDetailsByAdmin: "",
      })
        .then((response) => {
          this.setState({ showLoader: false, successModal: true });
          if (response.data.status === 200) {
            this.getProcessingAgentDetail();
            this.setState({
              errors: {},
            });
          }
        })
        .catch(() => {
          this.setState({
            showLoader: false,
          });
        });
    }
  };

  approvalSuccessModal = () => {
    this.setState({
      successModal: !this.state.successModal,
    });
    this.props.history.push("/processingagentlist");
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  submitReject = () => {
    if (
      this.state.rejectionReason &&
      this.state.description &&
      this.state.userId
    ) {
      let data = {
        reasonForRejection: this.state.rejectionReason,
        rejectionDetail: this.state.description,
        userId: this.state.userId,
      };
      delivaApiService("rejectDA", data)
        .then((response) => {
          this.setState({ showLoader: false });
          if (response.data.status === 200) {
            this.setState({
              showRejectModal: !this.state.showRejectModal,
            });
            this.props.history.push("/processingagentlist");
            this.getProcessingAgentDetail(data.userId);
          }
        })
        .catch(() => {
          this.setState({
            showLoader: false,
          });
        });
    } else {
      showErrorToast("Please write rejection details");
    }
  };

  getVerificationStatus = (status) => {
    const statusMap = {
      NOT_STARTED: "Not Started",
      PENDING: "Pending",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      DRAFT: "Draft",
    };
    return statusMap[status] || status;
  };

  operatingTime = (week) => {
    const { details } = this.state;
    let operatingTime = "Closed";
    const parcelCenter =
      this.state.selectedParcelCenter || details?.parcelCenter;
    const days = parcelCenter?.operationalHours?.days;

    if (Array.isArray(days)) {
      const dayInfo = days.find(
        (item) =>
          item?.dayName?.trim().toUpperCase() === week.trim().toUpperCase(),
      );

      if (
        dayInfo &&
        (dayInfo.open === true || String(dayInfo.open).toLowerCase() === "true")
      ) {
        operatingTime = `${dayInfo.startTime} - ${dayInfo.endTime}`;
      }
    }

    return operatingTime;
  };

  toggleAccordion = (section) => {
    this.setState((prevState) => ({
      expandedAccordions: {
        ...prevState.expandedAccordions,
        [section]: !prevState.expandedAccordions[section],
      },
    }));
  };

  getParcelCenterStatus = (parcelCenter) => {
    if (parcelCenter?.active || parcelCenter?.status === "APPROVED") {
      return "Active";
    }
    if (parcelCenter?.status === "REJECTED") {
      return "Rejected";
    }
    return "Inactive";
  };

  formatPhoneNumber = (countryCode, phone) => {
    const phoneText = String(phone || "").trim();
    if (!phoneText) return "N/A";
    if (phoneText.startsWith("+")) return phoneText;

    const normalizedCode = String(countryCode || "").replace(/\D/g, "");
    if (!normalizedCode) return phoneText;

    const normalizedPhone = phoneText.replace(/\D/g, "");
    if (normalizedPhone.startsWith(normalizedCode)) {
      return `+${normalizedCode} ${normalizedPhone.slice(normalizedCode.length)}`;
    }

    const nationalNumber = normalizedPhone.startsWith("0")
      ? normalizedPhone.slice(1)
      : normalizedPhone;
    return `+${normalizedCode} ${nationalNumber}`;
  };

  renderAccordionHeader = (section, title) => (
    <button
      type="button"
      className="accordion-header d-flex justify-content-between align-items-center"
      aria-expanded={Boolean(this.state.expandedAccordions[section])}
      onClick={() => this.toggleAccordion(section)}
    >
      <h5 className="mb-0">{title}</h5>
      <Image
        src={CaretCircleDownAccordion}
        alt=""
        className={`accordion-arrow ${this.state.expandedAccordions[section] ? "expanded" : ""}`}
      />
    </button>
  );

  render() {
    const { packageCOuntForPA, details, errors, selectedParcelCenter } =
      this.state;

    if (!details) {
      return null;
    }

    const parcelCenters = Array.isArray(details.parcelCenters)
      ? details.parcelCenters
      : details.parcelCenter
        ? [details.parcelCenter]
        : [];
    const hasMultipleParcelCenters =
      parcelCenters.length > 1 || Boolean(selectedParcelCenter);
    const parcelCenter =
      selectedParcelCenter ||
      (!hasMultipleParcelCenters
        ? parcelCenters[0] || details.parcelCenter
        : null);
    const adminVerification = details.administratorVerification;
    const signatureUrl = details.termsAgreement?.signatureUrl;
    const businessVerification = parcelCenter?.businessVerification;
    const isViewingSpecificCenter = Boolean(
      selectedParcelCenter && hasMultipleParcelCenters,
    );
    const canNavigateToOrders =
      !hasMultipleParcelCenters || isViewingSpecificCenter;
    const showStatArrows = !hasMultipleParcelCenters || isViewingSpecificCenter;
    return (
      <div className="page__wrapper h-100">
        <Header {...this.props} />

        <div className="mainContainer CustomerTable">
          <Row noGutters className="h-100">
            <Sidebar {...this.props} />
            <Col md={9} lg={10} className="boxTyp3">
              <div className="container-fluid">
                <div className="content-wrapper pa-verification-details">
                  {/* Header Section */}
                  <Row noGutters className="mb-3 align-items-center">
                    <Col md={6} lg={8} className="">
                      <h3 className="font-weight-normal fs-24 mb-0 line-ht color-33">
                        {isViewingSpecificCenter
                          ? parcelCenter?.name
                          : details?.businessName || parcelCenter?.name || ""}
                      </h3>
                      <h5 className="font-weight-normal mb-0 fs18 line-ht color-grey">
                        <span
                          onClick={() => {
                            if (isViewingSpecificCenter) {
                              this.showParcelCenterList();
                            } else {
                              this.props.history.push("/processingagentlist");
                            }
                          }}
                          className="pointer"
                        >
                          Parcel centres
                        </span>
                        <span className="icon-next mx-2 Fs12"></span>
                        {isViewingSpecificCenter
                          ? parcelCenter?.name
                          : details?.businessName || parcelCenter?.name || ""}
                      </h5>
                    </Col>
                    <Col md={6} lg={4} className="text-right">
                      {details && Object.keys(details).length > 0 && (
                        <button
                          className={`${
                            details.rejected ? "color-red" : "color-blue"
                          } background-none border-none fs20`}
                        >
                          {details.rejected
                            ? "Rejected"
                            : details.active
                              ? "In-process"
                              : "Pending"}
                        </button>
                      )}
                    </Col>
                  </Row>

                  {/* Statistics Cards - Positioned at top after header */}
                  <Row className="mb-3">
                    <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                      <div
                        className={`pa-stat-card ${
                          canNavigateToOrders ? "pointer" : ""
                        }`}
                        onClick={
                          canNavigateToOrders
                            ? () => {
                                this.props.history.push({
                                  pathname: "/totalprocessingorders/",
                                  state: {
                                    businessName: details.businessName || "",
                                  },
                                });
                              }
                            : undefined
                        }
                      >
                        <span className="pa-stat-icon pa-stat-icon-seal">
                          <Image src={SealCheck} alt="" />
                        </span>
                        <div className="pa-stat-copy">
                          <p className="pa-stat-value">
                            {this.state.totalTrips}
                          </p>
                          <p className="pa-stat-label">
                            {hasMultipleParcelCenters
                              ? "Overall order processed"
                              : "Total order processed"}
                          </p>
                        </div>
                        {showStatArrows && (
                          <Image
                            src={CaretRight}
                            alt=""
                            className="pa-stat-next"
                          />
                        )}
                      </div>
                    </Col>
                    <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                      <div className="pa-stat-card">
                        <span className="pa-stat-icon pa-stat-icon-up">
                          <Image src={BoxArrowUp} alt="" />
                        </span>
                        <div className="pa-stat-copy">
                          <p className="pa-stat-value">
                            {packageCOuntForPA.packageInHand || 0}
                          </p>
                          <p className="pa-stat-label">
                            {hasMultipleParcelCenters
                              ? "Overall package in hand"
                              : "Package in hand"}
                          </p>
                        </div>
                        {showStatArrows && (
                          <Image
                            src={CaretRight}
                            alt=""
                            className="pa-stat-next"
                          />
                        )}
                      </div>
                    </Col>
                    <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                      <div className="pa-stat-card">
                        <span className="pa-stat-icon pa-stat-icon-down">
                          <Image src={BoxArrowDown} alt="" />
                        </span>
                        <div className="pa-stat-copy">
                          <p className="pa-stat-value">
                            {packageCOuntForPA.incomingPackage || 0}
                          </p>
                          <p className="pa-stat-label">
                            {hasMultipleParcelCenters
                              ? "Overall incoming package"
                              : "Incoming package"}
                          </p>
                        </div>
                        {showStatArrows && (
                          <Image
                            src={CaretRight}
                            alt=""
                            className="pa-stat-next"
                          />
                        )}
                      </div>
                    </Col>
                    <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                      <div className="pa-stat-card">
                        <span className="pa-stat-icon pa-stat-icon-scroll">
                          <Image src={Scroll} alt="" />
                        </span>
                        <div className="pa-stat-copy">
                          <p className="pa-stat-value">
                            {packageCOuntForPA.requestCreated || 0}
                          </p>
                          <p className="pa-stat-label">
                            {hasMultipleParcelCenters
                              ? "Overall request created"
                              : "Request created"}
                          </p>
                        </div>
                        {showStatArrows && (
                          <Image
                            src={CaretRight}
                            alt=""
                            className="pa-stat-next"
                          />
                        )}
                      </div>
                    </Col>
                  </Row>

                  {/* Parcel Center Details - For single parcel center */}
                  {!hasMultipleParcelCenters && (
                    <div className="details-wrap single-center-details">
                      <Row noGutters>
                        <Col md={12}>
                          <h5 className="px-4">Parcel centre</h5>
                          <hr />
                        </Col>
                      </Row>
                      <Row className="px-4 pb-3">
                        <Col md={2}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Business name
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.name ||
                              details?.businessName ||
                              "N/A"}
                          </h5>
                        </Col>
                        <Col md={2}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Business type
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.businessType ||
                              details?.businessType ||
                              "N/A"}
                          </h5>
                        </Col>
                        <Col md={2}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Mobile number
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {this.formatPhoneNumber(
                              parcelCenter?.countryCode || details?.countryCode,
                              parcelCenter?.mobile || details?.mobile,
                            )}
                          </h5>
                        </Col>
                        <Col md={2}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Email
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.email || details?.email || "N/A"}
                          </h5>
                        </Col>
                        <Col md={2}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Administrator name
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {adminVerification?.fullName ||
                              details?.administratorName ||
                              "N/A"}
                          </h5>
                        </Col>
                      </Row>
                      <Row className="px-4 pb-3">
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Request type
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.requestType || "Local, Interstate"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Address
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.address || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Addition address
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.additionalAddress || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Parcel center capacity
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.capacity || "N/A"}
                          </h5>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* Parcel Center Details - When viewing specific center */}
                  {isViewingSpecificCenter && (
                    <div className="details-wrap selected-center-details">
                      <Row noGutters>
                        <Col md={12}>
                          <h5 className="px-4">Parcel centre details</h5>
                          <hr />
                        </Col>
                      </Row>
                      <Row className="px-4 pb-3">
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Business name
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.name || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Business type
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.businessType || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Mobile number
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {this.formatPhoneNumber(
                              parcelCenter?.countryCode || details?.countryCode,
                              parcelCenter?.mobile || details?.mobile,
                            )}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Email
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.email || details?.email || "N/A"}
                          </h5>
                        </Col>
                      </Row>
                      <Row className="px-4 pb-3">
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Request type
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.requestType || "Local, Interstate"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Address
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.address || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Addition address
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.additionalAddress || "N/A"}
                          </h5>
                        </Col>
                        <Col md={3}>
                          <h5 className="font-weight-normal color-grey fs14 mb-1">
                            Parcel center capacity
                          </h5>
                          <h5 className="fs16 font-weight-normal">
                            {parcelCenter?.capacity || "N/A"}
                          </h5>
                        </Col>
                      </Row>
                    </div>
                  )}

                  {/* Accordion Sections for Single Centre - Photos, Business Docs, Admin Docs */}
                  {!hasMultipleParcelCenters && !isViewingSpecificCenter && (
                    <>
                      <div className="details-wrap single-center-accordions mb-4">
                        {/* Photos of parcel center - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "photos",
                            "Photos of parcel center",
                          )}
                          {this.state.expandedAccordions.photos &&
                            parcelCenter?.photoUrls &&
                            parcelCenter.photoUrls.length > 0 && (
                              <Row className="pt-3 px-4">
                                {parcelCenter.photoUrls
                                  .slice(0, 4)
                                  .map((url, idx) => (
                                    <Col
                                      xs={6}
                                      md={3}
                                      key={idx}
                                      className="mb-2"
                                    >
                                      <Image
                                        src={url}
                                        alt={`Parcel center ${idx + 1}`}
                                        className="img-fluid parcel-photo"
                                      />
                                    </Col>
                                  ))}
                              </Row>
                            )}
                        </div>

                        {/* Business document - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "businessDocs",
                            "Business document",
                          )}
                          {this.state.expandedAccordions.businessDocs && (
                            <>
                              <Row className="pt-3 px-4">
                                <Col md={6} className="mb-3">
                                  <h5 className="font-weight-normal color-grey fs14 mb-1">
                                    Business name
                                  </h5>
                                  <h5 className="fs16 font-weight-normal">
                                    {businessVerification?.businessName ||
                                      parcelCenter?.name ||
                                      details.businessName ||
                                      "N/A"}
                                  </h5>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <h5 className="font-weight-normal color-grey fs14 mb-1">
                                    Business registration number
                                  </h5>
                                  <h5 className="fs16 font-weight-normal">
                                    {businessVerification?.businessRegistrationNumber ||
                                      parcelCenter?.businessRegistrationNumber ||
                                      parcelCenter?.registrationNumber ||
                                      "N/A"}
                                  </h5>
                                </Col>
                              </Row>
                              <Row className="px-4">
                                <Col md={12} className="mb-2">
                                  <h6 className="font-weight-normal color-grey mb-0">
                                    Business license photo
                                  </h6>
                                </Col>
                                {businessVerification?.businessDocumentUrls &&
                                businessVerification.businessDocumentUrls
                                  .length > 0 ? (
                                  businessVerification.businessDocumentUrls
                                    .slice(0, 4)
                                    .map((url, idx) => (
                                      <Col
                                        xs={6}
                                        md={3}
                                        key={idx}
                                        className="mb-2"
                                      >
                                        <Image
                                          src={url}
                                          alt={`Business document ${idx + 1}`}
                                          className="img-fluid doc-preview"
                                        />
                                      </Col>
                                    ))
                                ) : (
                                  <Col md={12}>
                                    <p className="text-muted">No documents</p>
                                  </Col>
                                )}
                                {businessVerification?.internationalDocumentUrls &&
                                  businessVerification.internationalDocumentUrls
                                    .length > 0 && (
                                    <>
                                      <Col md={12} className="mt-3 mb-2">
                                        <h6 className="font-weight-normal color-grey">
                                          International business documents
                                        </h6>
                                      </Col>
                                      {businessVerification.internationalDocumentUrls
                                        .slice(0, 4)
                                        .map((url, idx) => (
                                          <Col
                                            xs={6}
                                            md={3}
                                            key={idx}
                                            className="mb-2"
                                          >
                                            <Image
                                              src={url}
                                              alt={`International document ${idx + 1}`}
                                              className="img-fluid doc-preview"
                                            />
                                          </Col>
                                        ))}
                                    </>
                                  )}
                              </Row>
                            </>
                          )}
                        </div>

                        {/* Administrator document - Accordion */}
                        {adminVerification && (
                          <div className="accordion-section">
                            {this.renderAccordionHeader(
                              "adminDocs",
                              "Administrator document",
                            )}
                            {this.state.expandedAccordions.adminDocs && (
                              <Row className="pt-3 px-4">
                                <Col md={signatureUrl ? 4 : 6} className="mb-3">
                                  <p className="font-weight-normal color-grey fs14 mb-2">
                                    Personal govt ID
                                  </p>
                                  {adminVerification.govtIdImageUrls &&
                                  adminVerification.govtIdImageUrls.length >
                                    0 ? (
                                    <Image
                                      src={adminVerification.govtIdImageUrls[0]}
                                      alt="Government ID"
                                      className="img-fluid doc-preview"
                                    />
                                  ) : (
                                    <div className="placeholder-img">
                                      No image
                                    </div>
                                  )}
                                </Col>
                                <Col md={signatureUrl ? 4 : 6} className="mb-3">
                                  <p className="font-weight-normal color-grey fs14 mb-2">
                                    Selfie
                                  </p>
                                  {adminVerification.selfieImageUrl ? (
                                    <Image
                                      src={adminVerification.selfieImageUrl}
                                      alt="Selfie"
                                      className="img-fluid doc-preview"
                                    />
                                  ) : (
                                    <div className="placeholder-img">
                                      No image
                                    </div>
                                  )}
                                </Col>
                                {signatureUrl && (
                                  <Col md={4} className="mb-3">
                                    <p className="font-weight-normal color-grey fs14 mb-2">
                                      Signature of Parcel center owner
                                    </p>
                                    <Image
                                      src={signatureUrl}
                                      alt="Signature of Parcel center owner"
                                      className="img-fluid doc-preview"
                                    />
                                  </Col>
                                )}
                              </Row>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* Documents and verification are available in the Parcel centre accordions above. */}
                  {false && adminVerification && (
                    <>
                      <div className="details-wrap verification-card mb-3">
                        <Row noGutters>
                          <Col md={12}>
                            <h5 className="px-4">Administrator verification</h5>
                            <hr />
                          </Col>
                        </Row>
                        <div className="px-4 pb-3">
                          <Row className="mb-3">
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Full Name
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                {adminVerification.fullName || "N/A"}
                              </h5>
                            </Col>
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Status
                              </h5>
                              <h5 className="fs16 font-weight-normal color-red">
                                {this.getVerificationStatus(
                                  adminVerification.status,
                                )}
                              </h5>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-2">
                                Personal govt ID
                              </h5>
                              <div className="verification-img-container">
                                {adminVerification.govtIdImageUrls &&
                                adminVerification.govtIdImageUrls.length > 0 ? (
                                  <Image
                                    src={adminVerification.govtIdImageUrls[0]}
                                    alt="Government ID"
                                    className="img-fluid"
                                  />
                                ) : (
                                  <div className="placeholder-img">
                                    No image
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <h5 className="font-weight-normal color-grey fs14 mb-2">
                                Selfie
                              </h5>
                              <div className="verification-img-container">
                                {adminVerification.selfieImageUrl ? (
                                  <Image
                                    src={adminVerification.selfieImageUrl}
                                    alt="Selfie"
                                    className="img-fluid"
                                  />
                                ) : (
                                  <div className="placeholder-img">
                                    No image
                                  </div>
                                )}
                              </div>
                            </Col>
                          </Row>
                          <Row className="mb-2">
                            <Col md={12}>
                              <div className="checkboxContainer">
                                <input
                                  type="checkbox"
                                  id="adminVerify"
                                  name="adminVerification"
                                  checked={
                                    this.state.adminVerification ||
                                    details.active
                                  }
                                  onChange={this.onChange}
                                  disabled={details.active}
                                />
                                <label
                                  htmlFor="adminVerify"
                                  className="input-label"
                                >
                                  {details.active
                                    ? "Verified by admin"
                                    : "Verify by admin"}
                                </label>
                              </div>
                            </Col>
                          </Row>
                          {!details.active && this.state.adminVerification && (
                            <Row>
                              <Col
                                md={12}
                                className="d-flex"
                                style={{ gap: "12px" }}
                              >
                                <button
                                  className="df-button danger"
                                  style={{
                                    minWidth: "120px",
                                    flex: "none",
                                  }}
                                  onClick={this.handleReject.bind(
                                    this,
                                    details.userId,
                                  )}
                                >
                                  Reject
                                </button>
                                <button
                                  className="df-button success"
                                  style={{
                                    minWidth: "120px",
                                    flex: "none",
                                  }}
                                  onClick={this.approveDA.bind(
                                    this,
                                    details.userId,
                                    details.businessName,
                                  )}
                                >
                                  Approved
                                </button>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </div>
                      {!details.active && errors.adminVerification && (
                        <Row className="mb-3">
                          <Col md={12} className="text-center">
                            <p className="color-red fs14 mb-0">
                              {errors.adminVerification}
                            </p>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}

                  {/* Administrator details - For multiple parcel centers */}
                  {hasMultipleParcelCenters &&
                    !isViewingSpecificCenter &&
                    adminVerification && (
                      <>
                        <div className="details-wrap mb-4">
                          <Row noGutters>
                            <Col md={12}>
                              <h5 className="px-4">Administrator details</h5>
                              <hr />
                            </Col>
                          </Row>
                          <Row className="px-4 pb-3">
                            <Col md={4} className="mb-3 mb-md-0">
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Full name
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                {adminVerification.fullName ||
                                  details.businessName ||
                                  "N/A"}
                              </h5>
                            </Col>
                            <Col md={4} className="mb-3 mb-md-0">
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Mobile number
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                {this.formatPhoneNumber(
                                  details.countryCode,
                                  details.mobile,
                                )}
                              </h5>
                            </Col>
                            <Col md={4}>
                              <h5 className="font-weight-normal color-grey fs14 mb-1">
                                Email
                              </h5>
                              <h5 className="fs16 font-weight-normal">
                                {details.email || "N/A"}
                              </h5>
                            </Col>
                          </Row>
                          <div className="px-4 pb-3">
                            <div className="accordion-section">
                              {this.renderAccordionHeader(
                                "adminDocs",
                                "Administrator document",
                              )}
                              {this.state.expandedAccordions.adminDocs && (
                                <Row className="pt-3 px-4">
                                  <Col
                                    md={signatureUrl ? 4 : 6}
                                    className="mb-3"
                                  >
                                    <p className="font-weight-normal color-grey fs14 mb-2">
                                      Personal govt ID
                                    </p>
                                    {adminVerification.govtIdImageUrls &&
                                    adminVerification.govtIdImageUrls.length >
                                      0 ? (
                                      <Image
                                        src={
                                          adminVerification.govtIdImageUrls[0]
                                        }
                                        alt="Government ID"
                                        className="img-fluid doc-preview"
                                      />
                                    ) : (
                                      <div className="placeholder-img">
                                        No image
                                      </div>
                                    )}
                                  </Col>
                                  <Col
                                    md={signatureUrl ? 4 : 6}
                                    className="mb-3"
                                  >
                                    <p className="font-weight-normal color-grey fs14 mb-2">
                                      Selfie
                                    </p>
                                    {adminVerification.selfieImageUrl ? (
                                      <Image
                                        src={adminVerification.selfieImageUrl}
                                        alt="Selfie"
                                        className="img-fluid doc-preview"
                                      />
                                    ) : (
                                      <div className="placeholder-img">
                                        No image
                                      </div>
                                    )}
                                  </Col>
                                  {signatureUrl && (
                                    <Col md={4} className="mb-3">
                                      <p className="font-weight-normal color-grey fs14 mb-2">
                                        Signature of Parcel center owner
                                      </p>
                                      <Image
                                        src={signatureUrl}
                                        alt="Signature of Parcel center owner"
                                        className="img-fluid doc-preview"
                                      />
                                    </Col>
                                  )}
                                </Row>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                  {/* Legacy duplicate of the Parcel centre document accordions above */}
                  {false && businessVerification && (
                    <>
                      <div className="details-wrap mb-4">
                        <Row noGutters>
                          <Col md={12}>
                            <h5 className="px-4">Business verification</h5>
                            <hr />
                          </Col>
                        </Row>
                        <Row className="px-4 mb-3">
                          <Col md={6}>
                            <h5 className="font-weight-normal color-grey fs14 mb-1">
                              Business name
                            </h5>
                            <h5 className="fs16 font-weight-normal">
                              {businessVerification.businessName ||
                                parcelCenter.name}
                            </h5>
                          </Col>
                          <Col md={6}>
                            <h5 className="font-weight-normal color-grey fs14 mb-1">
                              Business registration number
                            </h5>
                            <h5 className="fs16 font-weight-normal">
                              {businessVerification.businessRegistrationNumber ||
                                "N/A"}
                            </h5>
                          </Col>
                        </Row>

                        {/* Parcel center photos - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "photos",
                            "Photos of parcel center",
                          )}
                          {this.state.expandedAccordions.photos &&
                            parcelCenter.photoUrls &&
                            parcelCenter.photoUrls.length > 0 && (
                              <Row className="pt-3 px-4">
                                {parcelCenter.photoUrls
                                  .slice(0, 4)
                                  .map((url, idx) => (
                                    <Col
                                      xs={6}
                                      md={3}
                                      key={idx}
                                      className="mb-2"
                                    >
                                      <Image
                                        src={url}
                                        alt={`Parcel center ${idx + 1}`}
                                        className="img-fluid parcel-photo"
                                      />
                                    </Col>
                                  ))}
                              </Row>
                            )}
                        </div>

                        {/* Business documents - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "businessDocs",
                            "Business document",
                          )}
                          {this.state.expandedAccordions.businessDocs && (
                            <Row className="pt-3 px-4">
                              {businessVerification.businessDocumentUrls &&
                              businessVerification.businessDocumentUrls.length >
                                0 ? (
                                businessVerification.businessDocumentUrls
                                  .slice(0, 4)
                                  .map((url, idx) => (
                                    <Col
                                      xs={6}
                                      md={3}
                                      key={idx}
                                      className="mb-2"
                                    >
                                      <Image
                                        src={url}
                                        alt={`Business document ${idx + 1}`}
                                        className="img-fluid doc-preview"
                                      />
                                    </Col>
                                  ))
                              ) : (
                                <Col md={12}>
                                  <p className="text-muted">No documents</p>
                                </Col>
                              )}
                            </Row>
                          )}
                        </div>

                        {/* International business documents - Accordion */}
                        {businessVerification.internationalBusiness && (
                          <div className="accordion-section">
                            {this.renderAccordionHeader(
                              "internationalDocs",
                              "International business documents",
                            )}
                            {this.state.expandedAccordions
                              .internationalDocs && (
                              <Row className="pt-3 px-4">
                                {businessVerification.internationalDocumentUrls &&
                                businessVerification.internationalDocumentUrls
                                  .length > 0 ? (
                                  businessVerification.internationalDocumentUrls
                                    .slice(0, 4)
                                    .map((url, idx) => (
                                      <Col
                                        xs={6}
                                        md={3}
                                        key={idx}
                                        className="mb-2"
                                      >
                                        <Image
                                          src={url}
                                          alt={`International document ${idx + 1}`}
                                          className="img-fluid doc-preview"
                                        />
                                      </Col>
                                    ))
                                ) : (
                                  <Col md={12}>
                                    <p className="text-muted">No documents</p>
                                  </Col>
                                )}
                                <Col md={12} className="mt-3">
                                  {!details.active && (
                                    <div className="verify-radio-wrap">
                                      <input
                                        type="checkbox"
                                        id="internationalVerify"
                                        name="internationalVerification"
                                        checked={
                                          this.state.internationalVerification
                                        }
                                        onChange={this.onChange}
                                        className="verify-radio-input"
                                      />
                                      <label
                                        htmlFor="internationalVerify"
                                        className="verify-radio-label"
                                      >
                                        Verify
                                      </label>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </div>
                        )}

                        {/* Administrator document - Accordion */}
                        {adminVerification && (
                          <div className="accordion-section">
                            {this.renderAccordionHeader(
                              "adminDocs",
                              "Administrator document",
                            )}
                            {this.state.expandedAccordions.adminDocs && (
                              <Row className="pt-3 px-4">
                                <Col md={6} className="mb-3">
                                  <p className="font-weight-normal color-grey fs14 mb-2">
                                    Personal govt ID
                                  </p>
                                  {adminVerification.govtIdImageUrls &&
                                  adminVerification.govtIdImageUrls.length >
                                    0 ? (
                                    <Image
                                      src={adminVerification.govtIdImageUrls[0]}
                                      alt="Government ID"
                                      className="img-fluid doc-preview"
                                    />
                                  ) : (
                                    <div className="placeholder-img">
                                      No image
                                    </div>
                                  )}
                                </Col>
                                <Col md={6} className="mb-3">
                                  <p className="font-weight-normal color-grey fs14 mb-2">
                                    Selfie
                                  </p>
                                  {adminVerification.selfieImageUrl ? (
                                    <Image
                                      src={adminVerification.selfieImageUrl}
                                      alt="Selfie"
                                      className="img-fluid doc-preview"
                                    />
                                  ) : (
                                    <div className="placeholder-img">
                                      No image
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            )}
                          </div>
                        )}
                        <Row noGutters>
                          <Col md={12}>
                            <hr />
                            <div className="verify-radio-wrap">
                              {details.active ? (
                                <>
                                  <input
                                    type="checkbox"
                                    id="notarionVerifyDisabled"
                                    name="notarionVerification"
                                    checked
                                    disabled
                                    className="verify-radio-input"
                                  />
                                  <label
                                    htmlFor="notarionVerifyDisabled"
                                    className="verify-radio-label"
                                  >
                                    Verified
                                  </label>
                                </>
                              ) : (
                                <>
                                  <input
                                    type="checkbox"
                                    id="notarionVerify"
                                    name="notarionVerification"
                                    checked={this.state.notarionVerification}
                                    onChange={this.onChange}
                                    className="verify-radio-input"
                                  />
                                  <label
                                    htmlFor="notarionVerify"
                                    className="verify-radio-label"
                                  >
                                    Verify
                                  </label>
                                </>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {!details.active && errors.businessVerification && (
                        <Row className="mb-3">
                          <Col md={12} className="text-center">
                            <p className="color-red fs14 mb-0 mt-2">
                              {errors.businessVerification}
                            </p>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}

                  {/* Photos and Documents for Specific Parcel Center */}
                  {isViewingSpecificCenter && businessVerification && (
                    <>
                      <div className="details-wrap selected-center-accordions mb-4">
                        {/* Photos of parcel center - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "photos",
                            "Photos of parcel center",
                          )}
                          {this.state.expandedAccordions.photos &&
                            parcelCenter?.photoUrls &&
                            parcelCenter.photoUrls.length > 0 && (
                              <Row className="pt-3 px-4">
                                {parcelCenter.photoUrls
                                  .slice(0, 4)
                                  .map((url, idx) => (
                                    <Col
                                      xs={6}
                                      md={3}
                                      key={idx}
                                      className="mb-2"
                                    >
                                      <Image
                                        src={url}
                                        alt={`Parcel center ${idx + 1}`}
                                        className="img-fluid parcel-photo"
                                      />
                                    </Col>
                                  ))}
                              </Row>
                            )}
                        </div>

                        {/* Business documents - Accordion */}
                        <div className="accordion-section">
                          {this.renderAccordionHeader(
                            "businessDocs",
                            "Business document",
                          )}
                          {this.state.expandedAccordions.businessDocs && (
                            <>
                              <Row className="pt-3 px-4">
                                <Col md={6} className="mb-3">
                                  <h5 className="font-weight-normal color-grey fs14 mb-1">
                                    Business name
                                  </h5>
                                  <h5 className="fs16 font-weight-normal">
                                    {businessVerification.businessName ||
                                      parcelCenter.name ||
                                      "N/A"}
                                  </h5>
                                </Col>
                                <Col md={6} className="mb-3">
                                  <h5 className="font-weight-normal color-grey fs14 mb-1">
                                    Business registration number
                                  </h5>
                                  <h5 className="fs16 font-weight-normal">
                                    {businessVerification.businessRegistrationNumber ||
                                      parcelCenter.businessRegistrationNumber ||
                                      parcelCenter.registrationNumber ||
                                      "N/A"}
                                  </h5>
                                </Col>
                              </Row>
                              <Row className="px-4">
                                <Col md={12} className="mb-2">
                                  <h6 className="font-weight-normal color-grey mb-0">
                                    Business license photo
                                  </h6>
                                </Col>
                                {businessVerification.businessDocumentUrls &&
                                businessVerification.businessDocumentUrls
                                  .length > 0 ? (
                                  businessVerification.businessDocumentUrls
                                    .slice(0, 4)
                                    .map((url, idx) => (
                                      <Col
                                        xs={6}
                                        md={3}
                                        key={idx}
                                        className="mb-2"
                                      >
                                        <Image
                                          src={url}
                                          alt={`Business document ${idx + 1}`}
                                          className="img-fluid doc-preview"
                                        />
                                      </Col>
                                    ))
                                ) : (
                                  <Col md={12}>
                                    <p className="text-muted">No documents</p>
                                  </Col>
                                )}
                              </Row>
                              {(businessVerification.internationalBusiness ||
                                businessVerification.internationalDocumentUrls
                                  ?.length > 0) && (
                                <Row className="pt-3 px-4">
                                  <Col md={12} className="mb-2">
                                    <h6 className="font-weight-normal color-grey mb-0">
                                      International business documents
                                    </h6>
                                  </Col>
                                  {businessVerification.internationalDocumentUrls &&
                                  businessVerification.internationalDocumentUrls
                                    .length > 0 ? (
                                    businessVerification.internationalDocumentUrls
                                      .slice(0, 4)
                                      .map((url, idx) => (
                                        <Col
                                          xs={6}
                                          md={3}
                                          key={idx}
                                          className="mb-2"
                                        >
                                          <Image
                                            src={url}
                                            alt={`International document ${idx + 1}`}
                                            className="img-fluid doc-preview"
                                          />
                                        </Col>
                                      ))
                                  ) : (
                                    <Col md={12}>
                                      <p className="text-muted">No documents</p>
                                    </Col>
                                  )}
                                </Row>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* Multiple Parcel Centers - List of Parcel Centers Table */}
                  {hasMultipleParcelCenters &&
                    !isViewingSpecificCenter &&
                    details.parcelCenters && (
                      <div className="mb-4">
                        <h5 className="mb-2">List of parcel centre</h5>
                        <div className="table-responsive">
                          <table className="table center-list-table">
                            <thead>
                              <tr>
                                <th>Registration No.</th>
                                <th>Business Name</th>
                                <th>Email</th>
                                <th>Contact</th>
                                <th>Location</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className="ttl-order-table">
                              {parcelCenters.map((center, idx) => {
                                const centerLocation =
                                  center.city ||
                                  center.address?.city ||
                                  center.location ||
                                  (typeof center.address === "string"
                                    ? center.address
                                    : "");
                                const mobile = center.mobile || details.mobile;
                                const centerStatus =
                                  this.getParcelCenterStatus(center);
                                const registrationNumber =
                                  center.businessVerification
                                    ?.businessRegistrationNumber ||
                                  center.businessRegistrationNumber ||
                                  "";

                                return (
                                  <tr
                                    key={
                                      center.parcelCenterId || center.id || idx
                                    }
                                  >
                                    <td>
                                      {registrationNumber
                                        ? `#${registrationNumber.replace(/^#/, "")}`
                                        : "-"}
                                    </td>
                                    <td className="text-capitalize">
                                      {center.name || "-"}
                                    </td>
                                    <td>{center.email || "N/A"}</td>
                                    <td>
                                      {mobile
                                        ? this.formatPhoneNumber(
                                            center.countryCode ||
                                              details.countryCode,
                                            mobile,
                                          )
                                        : "-"}
                                    </td>
                                    <td className="text-capitalize">
                                      {centerLocation || "-"}
                                    </td>
                                    <td>
                                      <span
                                        className={
                                          centerStatus === "Active"
                                            ? "text-green"
                                            : "text-reddish"
                                        }
                                      >
                                        {centerStatus}
                                      </span>
                                    </td>
                                    <td className="views-icos">
                                      <button
                                        type="button"
                                        className="pointer border-0 bg-transparent p-0"
                                        title="View"
                                        aria-label="View parcel center"
                                        onClick={() =>
                                          this.viewParcelCenter(center)
                                        }
                                      >
                                        <i
                                          className="icon-eye"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                  {/* Operational Hours and Banking Details */}
                  {(!hasMultipleParcelCenters || isViewingSpecificCenter) && (
                    <div className="card-layout-update">
                      <Row className="mb-3">
                        <Col lg={6} className="mb-3 mb-lg-0">
                          <div className="details-wrap optional-hrs">
                            <Row noGutters>
                              <Col md={12} lg={12} className="">
                                <h5 className="px-4">Operational Hours</h5>
                                <hr />
                              </Col>
                            </Row>
                            <div className="row m-0">
                              <div className="col-sm-6">
                                <ul className="hrs-list">
                                  {[
                                    "Monday",
                                    "Tuesday",
                                    "Wednesday",
                                    "Thursday",
                                  ].map((day) => (
                                    <li key={day}>
                                      <div className="row">
                                        <div className="col-sm-5">
                                          <span className="color-grey">
                                            {day}
                                          </span>
                                        </div>
                                        <div className="col-sm-7 text-right fw500">
                                          {this.operatingTime(day)}
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="col-sm-6">
                                <ul className="hrs-list">
                                  {["Friday", "Saturday", "Sunday"].map(
                                    (day) => (
                                      <li key={day}>
                                        <div className="row">
                                          <div className="col-sm-5">
                                            <span className="color-grey">
                                              {day}
                                            </span>
                                          </div>
                                          <div className="col-sm-7 text-right fw500">
                                            {this.operatingTime(day)}
                                          </div>
                                        </div>
                                      </li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </Col>

                        {/* Banking details */}
                        {(parcelCenter?.bankingDetails ||
                          details.bankingDetails) && (
                          <Col lg={6}>
                            <div className="details-wrap">
                              <Row noGutters>
                                <Col md={12} lg={12} className="">
                                  <h5 className="px-4">Banking Details</h5>
                                  <hr />
                                </Col>
                              </Row>
                              <div className="row px-4">
                                <div className="col-sm-6 mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Full Name
                                  </h5>
                                  <h5 className="fs18 font-weight-normal">
                                    {(
                                      parcelCenter?.bankingDetails ||
                                      details.bankingDetails
                                    )?.fullName || ""}
                                  </h5>
                                </div>
                                <div className="col-sm-6 mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Bank
                                  </h5>
                                  <h5 className="fs18 font-weight-normal">
                                    {(
                                      parcelCenter?.bankingDetails ||
                                      details.bankingDetails
                                    )?.bankName || ""}{" "}
                                    {(
                                      parcelCenter?.bankingDetails ||
                                      details.bankingDetails
                                    )?.bankLocation || ""}
                                  </h5>
                                </div>
                                <div className="col-sm-6 mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    Account Number
                                  </h5>
                                  <h5 className="fs18 font-weight-normal">
                                    {(
                                      parcelCenter?.bankingDetails ||
                                      details.bankingDetails
                                    )?.accountNumber || ""}
                                  </h5>
                                </div>
                                <div className="col-sm-6 mb-4">
                                  <h5 className="font-weight-normal color-grey fs18">
                                    ABA Number
                                  </h5>
                                  <h5 className="fs18 font-weight-normal">
                                    {(
                                      parcelCenter?.bankingDetails ||
                                      details.bankingDetails
                                    )?.abaNumber || "N/A"}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  )}

                  {/* Team of Parcel Center - For single centre only */}
                  {(!hasMultipleParcelCenters || isViewingSpecificCenter) && (
                    <div className="mb-4">
                      <h5 className="mb-2">
                        Team of parcel center ({parcelCenter?.team?.length || 0}
                        )
                      </h5>
                      <div className="table-responsive">
                        {parcelCenter?.team && parcelCenter.team.length > 0 ? (
                          <table className="table center-list-table">
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Type</th>
                                <th>Name</th>
                                <th>Email ID</th>
                                <th>Mobile no.</th>
                              </tr>
                            </thead>
                            <tbody>
                              {parcelCenter.team.map((member, idx) => (
                                <tr key={idx}>
                                  <td>{member.id ? `#${member.id}` : "N/A"}</td>
                                  <td>{member.type || "N/A"}</td>
                                  <td>{member.name || "N/A"}</td>
                                  <td>{member.email || "N/A"}</td>
                                  <td>
                                    {this.formatPhoneNumber(
                                      member.countryCode ||
                                        parcelCenter?.countryCode ||
                                        details.countryCode,
                                      member.mobile,
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-muted">No team members assigned</p>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <Footer {...this.props} />
            </Col>
          </Row>
        </div>

        {/* Reject Modal */}
        <Modal
          show={this.state.showRejectModal}
          onHide={this.handleReject.bind(this, "")}
          centered
          className="deliva-popup rejection-modal"
        >
          <Modal.Body>
            <div className="modal-content-wrap">
              <div className="text-center">
                <div className="reject-icon-circle">
                  <Image src={RejectIcon} className="img-fluid reject-icon" />
                </div>
                <h4 className="color-red mt-3 fs-22">
                  Are you sure to reject this request ?
                </h4>
                <p className="color-grey fs16">
                  Please add/choose the reason of rejection
                </p>
              </div>

              <Form.Group
                controlId="exampleForm.ControlSelect1"
                className="text-left"
              >
                <Form.Label className="color-head fs16">
                  Choose the Reason
                </Form.Label>
                <Form.Control
                  as="select"
                  name="rejectionReason"
                  onChange={this.onChange}
                  value={this.state.rejectionReason}
                  className="form-control-custom"
                >
                  <option value="Other">Other</option>
                  <option value="Invalid Passport Details">
                    Invalid Passport Details
                  </option>
                  <option value="Invalid Banking Details">
                    Invalid Banking Details
                  </option>
                  <option value="Invalid ID Proof">Invalid ID Proof</option>
                  <option value="Criminal Background">
                    Criminal Background
                  </option>
                </Form.Control>
              </Form.Group>

              <Form.Group
                controlId="exampleForm.ControlTextarea1"
                className="text-left"
              >
                <Form.Label className="color-head fs16">
                  Rejection details
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  name="description"
                  onChange={this.onChange}
                  maxLength="100"
                  placeholder="Write rejection details..."
                  className="form-control-custom"
                />
                <div className="text-right">
                  <span className="min-char color-grey">Min 100 chars</span>
                </div>
              </Form.Group>

              <Form.Group className="rejection-type-group text-left">
                <div className="d-flex align-items-center">
                  <div className="custom-radio-wrap mr-4">
                    <input
                      type="radio"
                      id="resubmission"
                      name="rejectionType"
                      value="resubmission"
                      checked={this.state.rejectionType === "resubmission"}
                      onChange={this.onChange}
                      className="custom-radio-input"
                    />
                    <label
                      htmlFor="resubmission"
                      className="custom-radio-label"
                    >
                      Resubmission
                    </label>
                  </div>
                  <div className="custom-radio-wrap">
                    <input
                      type="radio"
                      id="block"
                      name="rejectionType"
                      value="block"
                      checked={this.state.rejectionType === "block"}
                      onChange={this.onChange}
                      className="custom-radio-input"
                    />
                    <label htmlFor="block" className="custom-radio-label">
                      Block
                    </label>
                  </div>
                </div>
              </Form.Group>

              <div className="text-center mt-4">
                <button
                  className="btn-modal-secondary min-w-120 mr-3"
                  onClick={this.handleReject.bind(this, "")}
                >
                  No
                </button>
                <button
                  className="btn-modal-primary min-w-120"
                  onClick={this.submitReject.bind(this)}
                >
                  Yes
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Approval Success Modal */}
        <Modal
          show={this.state.successModal}
          onHide={() => this.approvalSuccessModal()}
          centered
        >
          <Modal.Body>
            <div className="modal-content-wrap text-center">
              <Image src={approved} className="img-fluid user-block-img" />
              <h4 className="lightGreenTex mt-3">Approved</h4>
              <p className="color-grey">
                {this.state.daName} #{this.state.userId} detail are approved
              </p>

              <button
                className="b1-btn min-w-80"
                onClick={() => this.approvalSuccessModal()}
              >
                Back
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default StoreProfile;
